import React from 'react'
import { LinkButton } from '@/atoms/Button'
import { ArrowRightIcon } from '@/atoms/Icons/ArrowRightIcon'
import { HeadingMD, ParagraphMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export const FilmmakerRelationshipSection: React.FC = () => {
  const { t } = useTranslate('create')

  return (
    <section
      className="w-full py-16 md:py-24"
      style={{
        backgroundImage: 'linear-gradient(130deg, #232323 0%, #141414 100%)',
      }}
    >
      <div className="mx-auto max-w-[1440px] px-4 md:px-12 lg:px-[120px]">
        <div className="text-center">
          <HeadingMD weight="bold" color="white" className="md:photon-heading-xl lg:photon-display mb-6">
            {t('whyBringYourStoryToAngel', 'Why Bring Your Story to Angel?')}
          </HeadingMD>
          <ParagraphMD weight="medium" color="core-gray-400" className="md:photon-paragraph-lg mx-auto mb-8 max-w-2xl">
            {t(
              'filmmakersPartnershipBenefits',
              "Filmmakers earn through Angel's revenue-sharing models while retaining full creative control.",
            )}
          </ParagraphMD>
          <LinkButton
            href="/filmmakers"
            variant="white"
            className="inline-flex items-center gap-3 rounded-[14px] px-8 py-4"
          >
            {t('learnMore', 'Learn More')}
            <ArrowRightIcon size={20} color="core-gray-950" />
          </LinkButton>
        </div>
      </div>
    </section>
  )
}
